module.exports = __webpack_public_path__ + "static/media/fss.20126542.png";